import styled from "styled-components";

export const SkillsStyles = styled.div`
    margin-top: 5rem;
    padding: 0 0 4rem;
    width: 100%;

    & .skill-content {
        flex: 0 0 100%;
        max-width: 100%;

        & .skill-item {
            flex: 0 0 50%;
            max-width: 50%;
            padding: 0 1.5rem;
            margin-bottom: 4rem;

            & p {
                font-size: 1.6rem;
                color: var(--color-text);
                text-transform: capitalize;
                margin: 0 0 10px;
            }

            & .progress {
                height: 2rem;
                border-radius: 10px;
                position: relative;

                & .progress-bar {
                    background-color: var(--color-text);
                    height: 6px;
                    position: absolute;
                    left: 7px;
                    top: 7px;
                    border-radius: 20px;
                    
                    & span {
                        position: absolute;
                        top: 0;
                        right: 0;
                        font-size: 1.6rem;
                        font-weight: 600;
                        color: var(--color-text);
                        margin-top: -40px;
                    }
                }
            }
        }
    }

`;